<template>
  <button
    class="py-2 px-4 rounded shadow font-medium flex items-center justify-center"
    :class="{
      'w-full': fullWidth,
      'bg-primary text-white': (color === 'primary'),
      'bg-secondary text-white': (color === 'secondary'),
      'bg-gray-500 text-white': (color === 'gray'),
      'bg-black text-white': (color === 'black'),
      'bg-white': (color === 'white' || outlined),
      'text-secondary border-2 border-secondary': outlined,
      'cursor-not-allowed opacity-60': disableButton,
      'transition filter hover:brightness-110': !disableButton,
      'uppercase': !noCaps,
      'rounded-full px-0 py-0': iconCircle
    }"
    :disabled="disableButton"
  >
    <slot name="prepend" />
    <template v-if="loading">
      <tw-spinner size="sm" />
    </template>
    <template v-else>
      <slot name="label" />
      <span v-html="label" />
    </template>
    <slot name="append" />
  </button>
</template>

<script>
import TwSpinner from "@/components/Tailwind/TwSpinner";

export default {
  name: "TwButton",
  components: { TwSpinner },
  props: {
    color: {
      type: String,
      default: "primary",
      validator(value) {
        return ["primary", "secondary", "gray", "black", "white"].includes(value)
      }
    },
    label: {
      type: String,
      require: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    noCaps: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    iconCircle: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disableButton() {
      return this.disabled || this.loading;
    }
  }
}

</script>